/**
 * Vertical Centering Utilities
 * 
 * Shared utilities for handling vertical centering of content when scrolling is not needed
 */

const verticalCenteringUtils = {
  /**
   * Sets up vertical centering when no scrolling is needed
   * @param {string} containerId - ID of the container element
   * @param {string} componentName - Name of the component for logging (optional)
   */
  setupVerticalCentering: function(containerId, componentName = 'Component') {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    // Find the content wrapper inside the container
    const contentWrapper = container.querySelector('div[class*="flex"]');
    if (!contentWrapper) {
      console.log(`Content wrapper not found for vertical centering in ${componentName}`);
      return;
    }
    
    console.log(`Setting up vertical centering for ${componentName}:`, containerId);
    
    // Function to check if scrolling is needed and adjust centering
    const checkAndCenter = () => {
      const hasScrollbar = container.scrollHeight > container.clientHeight;
      console.log(`Checking scroll for ${componentName}:`, { 
        hasScrollbar, 
        scrollHeight: container.scrollHeight, 
        clientHeight: container.clientHeight 
      });
      
      if (hasScrollbar) {
        // Content overflows - remove centering, allow normal flow
        container.classList.remove('items-center', 'justify-center');
        container.classList.add('items-start');
        console.log(`Applied normal flow (no centering) for ${componentName}`);
      } else {
        // No overflow - center vertically
        container.classList.remove('items-start');
        container.classList.add('items-center', 'justify-center');
        console.log(`Applied vertical centering for ${componentName}`);
      }
    };
    
    // Make container a flex container for centering to work
    container.classList.add('flex', 'flex-col');
    
    // Check initially after a short delay to ensure content is fully rendered
    setTimeout(checkAndCenter, 200);
    
    // Check on window resize
    window.addEventListener('resize', checkAndCenter);
    
    // Use ResizeObserver if available to detect content size changes
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(checkAndCenter);
      resizeObserver.observe(container);
    }
  }
};

// Make available globally
window.verticalCenteringUtils = verticalCenteringUtils;